(function () {
    var registryKey = '__pfuProductQuickAddFeedback';

    if (window[registryKey] && window[registryKey].initialized) {
        return;
    }

    var api = window[registryKey] = {
        initialized: true
    };
    var pendingForms = [];
    var successEvents = [
        'cart:add',
        'cart:added',
        'cart:change',
        'cart:updated',
        'cart:update',
        'product:added',
        'product:added-to-cart',
        'ajaxProduct:added'
    ];
    var failureEvents = [
        'cart:error',
        'cart:failed',
        'product:error',
        'ajaxProduct:error'
    ];

    function getLabelNode(control) {
        return control && (control.querySelector('[data-pfu-quick-add-label]') || control);
    }

    function getFormControls(form) {
        return Array.prototype.slice.call(form.querySelectorAll('[data-pfu-quick-add-native-button]'));
    }

    function getPrimaryControl(controls) {
        return controls.find(function (control) {
            return !control.hasAttribute('data-pfu-quick-add-icon');
        }) || controls[0];
    }

    function setMessage(entry, text) {
        if (entry && entry.message) {
            entry.message.textContent = text || '';
        }
    }

    function setControlText(control, text) {
        var label = getLabelNode(control);

        if (label && !control.hasAttribute('data-pfu-quick-add-icon')) {
            label.textContent = text;
        }
    }

    function setBusy(control, busy) {
        if (!control) {
            return;
        }

        control.classList.toggle('is-loading', busy);
        if (busy) {
            control.classList.remove('is-added');
        }
        control.toggleAttribute('aria-busy', busy);

        if (busy) {
            control.disabled = true;
        } else if (control.getAttribute('data-pfu-quick-add-state') !== 'sold-out') {
            control.disabled = false;
        }
    }

    function restoreForm(entry) {
        if (!entry || !entry.controls || !entry.controls.length) {
            return;
        }

        entry.controls.forEach(function (control) {
            if (!document.contains(control)) {
                return;
            }

            setControlText(control, entry.label);
            control.classList.remove('is-added');
            setBusy(control, false);
        });
    }

    function markAdded(entry) {
        if (!entry || !entry.controls || !entry.controls.length) {
            return;
        }

        window.clearTimeout(entry.timeout);
        setMessage(entry, '');
        entry.controls.forEach(function (control) {
            if (!document.contains(control)) {
                return;
            }

            setControlText(control, entry.addedLabel);
            control.classList.add('is-added');
            setBusy(control, false);
        });
        window.setTimeout(function () {
            restoreForm(entry);
        }, 1200);
    }

    function handleSubmit(event) {
        var form = event.target && event.target.closest ? event.target.closest('form.pfu-quick-add__form') : null;
        var controls;
        var control;
        var entry;

        if (!form) {
            return;
        }

        controls = getFormControls(form);
        control = getPrimaryControl(controls);

        if (!control || controls.some(function (item) { return item.disabled || item.classList.contains('is-loading'); })) {
            return;
        }

        entry = {
            form: form,
            control: control,
            controls: controls,
            message: form.closest('[data-pfu-quick-add]')?.querySelector('[data-pfu-quick-add-message]'),
            label: control.getAttribute('data-label') || 'Add to Cart',
            addedLabel: control.getAttribute('data-added-label') || 'Added \u2713',
            addingLabel: control.getAttribute('data-adding-label') || 'Adding...',
            timeout: null
        };

        pendingForms.push(entry);
        setMessage(entry, '');
        controls.forEach(function (item) {
            setControlText(item, entry.addingLabel);
            setBusy(item, true);
        });

        entry.timeout = window.setTimeout(function () {
            restoreForm(entry);
            setMessage(entry, 'Unable to add. Try again.');
            pendingForms = pendingForms.filter(function (item) {
                return item !== entry;
            });
        }, 8000);
    }

    function handleNativeSuccess() {
        var entry = pendingForms.shift();

        if (entry) {
            markAdded(entry);
        }
    }

    function handleNativeFailure() {
        var entry = pendingForms.shift();

        if (entry) {
            window.clearTimeout(entry.timeout);
            restoreForm(entry);
            setMessage(entry, 'Unable to add. Try again.');
        }
    }

    document.addEventListener('submit', handleSubmit, true);
    successEvents.forEach(function (eventName) {
        document.addEventListener(eventName, handleNativeSuccess);
        window.addEventListener(eventName, handleNativeSuccess);
    });
    failureEvents.forEach(function (eventName) {
        document.addEventListener(eventName, handleNativeFailure);
        window.addEventListener(eventName, handleNativeFailure);
    });

    document.addEventListener('shopify:section:unload', function (event) {
        pendingForms = pendingForms.filter(function (entry) {
            if (event.target && entry.form && event.target.contains(entry.form)) {
                window.clearTimeout(entry.timeout);
                return false;
            }

            return true;
        });
    });
})();
